import { Injectable } from '@angular/core';
import { URLS } from '../constants/constants';
import { HeaderType } from '../enums/enums';
import { QuestionPayload, TopicPayload } from '../models/faq.model';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  constructor(private http: HttpService) {}

  getFaqList() {
    return this.http.get(`${URLS.topic}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  addTopic(payload: TopicPayload) {
    return this.http.post(`${URLS.topic}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  updateTopic(id: string, payload: TopicPayload) {
    return this.http.put(`${URLS.topic}/${id}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  deleteTopic(id: string) {
    return this.http.delete(`${URLS.topic}/${id}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  addQuestion(payload: QuestionPayload) {
    return this.http.post(`${URLS.question}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  updateQuestion(id: string, payload: QuestionPayload) {
    return this.http.put(`${URLS.question}/${id}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  deleteQuestion(id: string) {
    return this.http.delete(`${URLS.question}/${id}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }
}
